<template>
  <button type="button" class="options-menu-footer-link" @click="$emit('select')">
    <span class="options-menu-footer-link__glyph" aria-hidden="true" :style="{ '--options-icon': iconMask }"></span>
    <span class="options-menu-footer-link__label">{{ label }}</span>
  </button>
</template>

<script setup>
// A link rather than a tile, centred at the foot of an OptionsMenuModal — the apps' "Contact
// support" (MapOptionsFooterLink). On web it carries "Report an issue".
import { computed } from 'vue'
import { optionsIconMask } from './optionsIcons'

const props = defineProps({
  icon: { type: String, required: true },
  label: { type: String, required: true },
});
defineEmits(['select']);

const iconMask = computed(() => optionsIconMask(props.icon))
</script>

<style scoped>
.options-menu-footer-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 10px 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}

.options-menu-footer-link:focus-visible {
  outline: 2px solid var(--yellow, #fddf00);
  outline-offset: 2px;
  border-radius: 8px;
}

.options-menu-footer-link__glyph {
  width: 14px;
  height: 14px;
  background-color: #fff;
  -webkit-mask: var(--options-icon) center / contain no-repeat;
  mask: var(--options-icon) center / contain no-repeat;
}

.options-menu-footer-link__label {
  text-decoration: underline;
  text-underline-offset: 3px;
}
</style>
